import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-serviceprovide',
  templateUrl: './serviceprovide.component.html',
  styleUrls: ['./serviceprovide.component.css']
})
export class ServiceprovideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
